
const settings = () => Object.assign({endpoint: '', currency: 'SEK', i18n: {}}, window.sswsTicker || {});

const escapeHtml = (value) => String(value === null || value === undefined ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');

const label = (key, fallback) => {
    const {i18n} = settings();
    return escapeHtml(i18n && i18n[key] ? i18n[key] : fallback);
};

const title = (data, options) => {
    if (options.name) {
        return escapeHtml(options.name);
    }
    const instrument = data.instrument || {};
    return escapeHtml(`${instrument.symbol || ''} ${instrument.exchange || ''}`.trim());
};

const currency = (data) => escapeHtml((data.instrument && data.instrument.currency) || settings().currency);

const templates = {
    default(data) {
        const f = data.formatted;
        const percent = data.value && data.value.diffpercent ? ` (${escapeHtml(f.diffpercent)}%)` : '';

        return `<table cellpadding="0" cellspacing="0" border="0" class="ticker-table">
  <tbody>
    <tr>
      <th>${label('last', 'Last')}</th>
      <th rowspan="2"><div class="trend ${escapeHtml(data.trend)}"></div></th>
      <th>${label('change', 'Change')}</th>
      <th>${label('volume', 'Volume')}</th>
      <th>${label('date', 'Date')}</th>
    </tr>
    <tr>
      <td>${escapeHtml(f.last)}</td>
      <td>${escapeHtml(f.diff)}${percent}</td>
      <td>${escapeHtml(f.volume)}</td>
      <td>${escapeHtml(f.date)}</td>
    </tr>
  </tbody>
</table>`;
    },

    table(data) {
        const f = data.formatted;

        return `<table class="table">
  <thead>
    <tr>
      <th>${label('last', 'Last')}</th>
      <th></th>
      <th>${label('change', 'Change')}</th>
      <th>${label('volume', 'Volume')}</th>
      <th>${label('date', 'Date')}</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>${escapeHtml(f.last)}</td>
      <td><div class="trend ${escapeHtml(data.trend)}"></div></td>
      <td>${escapeHtml(f.diff)} (${escapeHtml(f.diffpercent)})</td>
      <td>${escapeHtml(f.volume)}</td>
      <td>${escapeHtml(f.date)}</td>
    </tr>
  </tbody>
</table>`;
    },

    block(data, options) {
        const f = data.formatted;

        return `<div class="ticker-inside">
  <div class="ticker-title">${title(data, options)}</div>
  <div class="ticker-date">
    <div class="ticker-label">${label('date', 'Date')}</div>
    <div class="value">${escapeHtml(f.date)}</div>
  </div>
  <div class="ticker-last">
    <div class="ticker-label">${label('last', 'Last')}</div>
    <div class="value">${escapeHtml(f.last)} <span>${currency(data)}</span></div>
    <div class="ticker-trend">
      <div class="ticker-label">${label('trend', 'Trend')}</div>
      <div class="value"><div class="trend ${escapeHtml(data.trend)}"></div></div>
    </div>
  </div>
  <div class="ticker-change">
    <div class="ticker-label">${label('change', 'Change')}</div>
    <div class="value">${escapeHtml(f.diff)} <span>(${escapeHtml(f.diffpercent)}%)</span></div>
  </div>
  <div class="ticker-volume">
    <div class="ticker-label">${label('volume', 'Volume')}</div>
    <div class="value">${escapeHtml(f.volume)}</div>
  </div>
</div>`;
    },
};

class Ticker {
    constructor(element) {
        this.element = element;
        this.target = element.querySelector('.ticker-content') || element;
        this.symbol = element.getAttribute('data-symbol') || '';
        this.style = element.getAttribute('data-style') || 'default';
        this.name = element.getAttribute('data-name') || '';
        this.updates = 0;
        this.timer = null;

        const interval = parseInt(element.getAttribute('data-interval'), 10) || 0;
        this.interval = interval > 0 ? Math.min(Math.max(interval, 5), 1440) : 0;
        this.maxUpdates = this.interval > 0 ? Math.ceil(15000 / this.interval) : 0;
    }

    start() {
        this.refresh();

        if (this.interval > 0) {
            this.timer = window.setInterval(() => this.tick(), this.interval * 1000);
        }
    }

    stop() {
        if (this.timer !== null) {
            window.clearInterval(this.timer);
            this.timer = null;
        }
    }

    tick() {
        this.updates += 1;

        if (this.updates >= this.maxUpdates) {
            this.stop();
        }

        this.refresh();
    }

    refresh() {
        const {endpoint} = settings();

        if (!endpoint || !this.symbol) {
            return;
        }

        $.ajax({
            url: endpoint,
            data: {symbol: this.symbol},
            dataType: 'json',
            cache: false, // bypass page/CDN caches, the endpoint caches server side
        })
                .done((data) => this.render(data))
                .fail((xhr) => {
                    console.warn(`sswsticker: could not load the share price (HTTP ${xhr.status}).`);
                });
    }

    render(data) {
        if (!data || !data.formatted) {
            return;
        }

        const template = templates[this.style] || templates.default;

        this.target.innerHTML = template(data, {name: this.name});

        if ($.fn.matchHeight) {
            $.fn.matchHeight._applyDataApi();
        }
    }
}

export default {
    init() {
        $('[data-ssws-ticker]').each((index, element) => {
            new Ticker(element).start();
        });
    },
};
